var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BellSimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M5.24892 9.75C5.24896 8.85923 5.42531 7.97727 5.7678 7.15497C6.11028 6.33266 6.61213 5.58627 7.24442 4.95883C7.87671 4.33138 8.62693 3.83528 9.45184 3.49912C10.2768 3.16296 11.16 2.99339 12.0508 3.00019C15.773 3.02778 18.7503 6.11281 18.7503 9.83474V10.5C18.7503 13.8577 19.4548 15.8062 20.0753 16.8711C20.142 16.985 20.1775 17.1145 20.1781 17.2466C20.1788 17.3786 20.1445 17.5084 20.0789 17.623C20.0132 17.7375 19.9185 17.8327 19.8042 17.8989C19.69 17.9651 19.5603 18 19.4283 18H4.57015C4.43811 18 4.30841 17.9651 4.19417 17.8989C4.07992 17.8327 3.98519 17.7375 3.91955 17.6229C3.8539 17.5083 3.81967 17.3785 3.82032 17.2464C3.82097 17.1144 3.85647 16.9848 3.92324 16.8709C4.54408 15.806 5.24892 13.8575 5.24892 10.5V9.75Z",
    fill: "url(#paint0_linear_554_1584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 21H15",
    stroke: "url(#paint1_linear_554_1584)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.26855 9.75C5.26731 8.86051 5.44213 7.97957 5.78294 7.15795C6.12375 6.33634 6.62381 5.59031 7.25429 4.96286C7.88476 4.33541 8.6332 3.83895 9.45644 3.5021C10.2797 3.16524 11.1615 2.99466 12.0509 3.00019C15.7625 3.02778 18.7312 6.11281 18.7312 9.83474V10.5C18.7312 13.8577 19.4337 15.8062 20.0524 16.8711C20.1191 16.9849 20.1546 17.1142 20.1553 17.2461C20.156 17.378 20.1219 17.5077 20.0565 17.6222C19.991 17.7367 19.8966 17.8319 19.7826 17.8982C19.6686 17.9646 19.5392 17.9997 19.4073 18H4.59173C4.45985 17.9997 4.33038 17.9645 4.2164 17.8982C4.10242 17.8318 4.00795 17.7366 3.94252 17.6221C3.8771 17.5076 3.84303 17.3778 3.84376 17.2459C3.84449 17.1141 3.87999 16.9847 3.94667 16.8709C4.56573 15.806 5.26855 13.8575 5.26855 10.5L5.26855 9.75Z",
    stroke: "url(#paint2_linear_554_1584)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_1584",
    x1: 20.1781,
    y1: 9.375,
    x2: 3.82031,
    y2: 9.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_554_1584",
    x1: 15,
    y1: 21.425,
    x2: 9,
    y2: 21.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_554_1584",
    x1: 20.1553,
    y1: 9.37503,
    x2: 3.84375,
    y2: 9.37503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSimple);
export default __webpack_public_path__ + "static/media/BellSimple.1b110f5515f158187b6efe5afb1f80ca.svg";
export { ForwardRef as ReactComponent };